import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServerTokenService } from '../../../services/server-token.service';
import {
  Category,
  CategoryWithSources,
  DeclineReasonSettingsBatchBody,
  GroupedSettingsResponse,
} from '../interfaces/decline-reason-mapping.interface';

@Injectable({ providedIn: 'root' })
export class DeclineReasonMappingService {
  private readonly base = 'snfs/decline-reasons';

  constructor(private server: ServerTokenService) {}

  getCategories(): Observable<CategoryWithSources[]> {
    return this.server.getWithToken<CategoryWithSources[]>(`${this.base}/categories`);
  }

  createCategory(payload: { name: string }): Observable<Category> {
    return this.server.postWithToken<Category>(`${this.base}/categories`, payload);
  }

  updateCategory(id: string, payload: { name: string }): Observable<Category> {
    return this.server.patchWithToken<Category>(`${this.base}/categories/${id}`, payload);
  }

  deleteCategory(id: string): Observable<void> {
    return this.server.deleteWithToken<void>(`${this.base}/categories/${id}`);
  }

  getSettings(): Observable<GroupedSettingsResponse> {
    return this.server.getWithToken<GroupedSettingsResponse>(`${this.base}/settings`);
  }

  batchUpdateSettings(payload: DeclineReasonSettingsBatchBody): Observable<void> {
    return this.server.postWithToken<void>(`${this.base}/settings/batch`, payload);
  }

  getEhrNames(): Observable<{ names: string[] }> {
    return this.server.getWithToken<{ names: string[] }>('snfs/getEhrNames');
  }

  loadAll(): Observable<{ categories: CategoryWithSources[]; settings: GroupedSettingsResponse; ehrNames: string[] }> {
    return forkJoin({
      categories: this.getCategories(),
      settings: this.getSettings(),
      ehrNames: this.getEhrNames().pipe(map((res: { names: string[] }) => res.names)),
    });
  }
}
